import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, debounceTimeout = 500, callback: (term: T) => void = null): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
      callback?.(value);
    }, debounceTimeout);
    return () => clearTimeout(timeout);
  }, [callback, debounceTimeout, value]);

  return debouncedValue;
}
